let pendingReset: Promise<void> = Promise.resolve();

/** `WorkspaceChangeReset` records here the cache reset that it starts. */
export function setPendingWorkspaceReset(reset: Promise<void>): void {
  pendingReset = reset;
}

/**
 * Resolves when the last cache reset after a workspace change is complete. A caller that applies
 * a new session token waits for it, so that its next step sees the data of the new workspace.
 */
export function waitForWorkspaceReset(): Promise<void> {
  return pendingReset;
}
